export const DEFAULT_DOCUMENTARY_FEE_PERCENTAGE = 1.5;
export const DEFAULT_REGISTRATION_FEE_PERCENTAGE = 0.25;
export const DEFAULT_TRANSFER_FEE_PERCENTAGE = 0.1;
export const DEFAULT_NOTARIAL_FEE_PERCENTAGE = 0.5;
export const DEFAULT_ADMIN_FEE = 30000;